import dynamic from 'next/dynamic';
const SweetAlert = dynamic(() => import('app/components/layouts/Modals/SweetAlert'), {
  ssr: false,
});

const Modal = (props) => {
  return (
    <div>
      <SweetAlert {...props} showCloseButton={true}>
        { props.children }
      </SweetAlert>
      <style jsx global>{`
        #swal2-title {
          font-size: 22px;
          padding: 30px 30px 15px 30px;
        }

        #swal2-html-container {
          font-size: 16px;
        }

        .swal2-shown {
          padding-right: 0px !important;
        }
      `}</style>

    </div>
  );
}

export default Modal
